import { ArrowLeft, Headphones } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { pageRoutes } from '../../constants/routes';

const SUPPORT_EMAIL = 'techsupport@kickdrumtech.com';

interface OnboardingSubHeaderProps {
  title: string;
  showBackButton?: boolean;
  backRoute?: string;
}

function OnboardingSubHeader({
  title,
  showBackButton = false,
  backRoute = pageRoutes.onboarding,
}: OnboardingSubHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="border-b border-gray-300 bg-white shadow-sm">
      <div className="flex items-center justify-between gap-4 px-8 py-4">
        <div className="flex min-w-0 items-center gap-4">
          {showBackButton && (
            <>
              <button
                type="button"
                onClick={() => navigate(backRoute)}
                className="flex items-center gap-2 text-gray-600 transition-colors hover:text-brand"
              >
                <ArrowLeft className="h-5 w-5" />
                <span className="text-sm font-medium">Back</span>
              </button>
              <div className="h-6 w-px bg-gray-300" />
            </>
          )}
          <h2 className="truncate text-xl font-bold text-brand">{title}</h2>
        </div>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="flex shrink-0 items-center gap-2 text-sm font-medium text-brand hover:text-brand-hover"
        >
          <Headphones className="h-4 w-4 shrink-0 text-brand" aria-hidden />
          <span className="underline decoration-1 underline-offset-4">
            {SUPPORT_EMAIL}
          </span>
        </a>
      </div>
    </div>
  );
}

export default OnboardingSubHeader;
